import React, { useEffect, useState } from 'react';
import {
  TermsOfServiceContainer,
  TermsOfServiceColumn,
  TermsOfServiceTitle,
  TermsOfServiceContent,
  TermsOfServiceAcceptArea,
  TermsOfServiceCheckboxContent,
  TermsOfServiceCheckbox,
  TermsOfServiceCheckboxLabel,
  TermsOfServiceButton,
  TermsOfServiceCopyright,
  TermsOfServiceCopyrightImage,
  TermsOfServiceCopyrightTextLine,
  ProspectingSubtitleParagraph,
  ProspectingParagraph,
  ProspectingNumericList,
  ProspectingNumericListLine,
  ProspectingUnderlineParagraph,
  ProspectingSubtitleParagraphNormal,
  ProspectingParagraphLink
} from './styles';
import { BsCheck } from 'react-icons/bs';
import loginWoman from '../../assets/images/login-woman.svg';
import copyrightImage from '../../assets/images/copyright-image.svg';
import { acceptTermsOfService } from '../../services/termsOfService';
import { useHistory } from 'react-router';
import colors from '../../assets/styles/colors';

const TermsOfServicePage = () => {
  const history = useHistory();
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const [toggleCheckbox, setToggleCheckbox] = useState(false);
  const [scrollTerms, setScrollTerms] = useState(false);
  const [enableButton, setEnableButton] = useState(false);

  async function acceptTermsOfServiceAction() {
    try {
      let data = {
        id: session.idAsesor,
        aceptaCondiciones: true
      }

      await acceptTermsOfService(data);
      history.push('/admin/dashboard');
    } catch (error) {
      console.log(error.reponse);
    }

  }
  
  useEffect(() => {
    const element = document.getElementById('terms-of-service-scroll');

    element.addEventListener('scroll', function() {
      let value = parseInt(100 * element.scrollTop / (element.scrollHeight - element.clientHeight))
      
      if(value === 100) {
        setScrollTerms(true)
      }
    })
  }, []);

  useEffect(() => {
    if(toggleCheckbox && scrollTerms) {
      setEnableButton(true)
    }
  }, [toggleCheckbox, scrollTerms])

  return (
    <TermsOfServiceContainer id="terms-of-service-page">
      <TermsOfServiceColumn>
        <img src={loginWoman} height="100%" alt="Manager Woman" />
      </TermsOfServiceColumn>
      <TermsOfServiceColumn>
        <TermsOfServiceTitle>Terminos y condiciones</TermsOfServiceTitle>

        <TermsOfServiceContent id="terms-of-service-scroll">

          <ProspectingSubtitleParagraph>Uso de la Aplicación.</ProspectingSubtitleParagraph>
          <ProspectingNumericList>
            <ProspectingNumericListLine>
              Al utilizar los servicios dispuestos en la aplicación creada por ExcelCredit S.A.,
              el usuario acepta expresamente estar vinculado a estos términos y condiciones establecidos por la sociedad.
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Dentro de la publicación se establecerá la fecha en que empezarán a regir los términos y condiciones.
              ExcelCredit S.A., el usuario declara que conoce que la sociedad podrá modificar los términos sin aviso previo,
              en el momento que se ejecute un cambio se notificará al usuario y se publicarán el documento con las modificaciones
              con la fecha de entrada en vigencia.
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Para ver la actualización de los términos y condiciones, el usuario deberá verificar la sección en la aplicación que
              encontrará en el sitio web, en el enlace de términos y condiciones.
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              El usuario se compromete a cumplir con los términos y condiciones de las demás herramientas que puedan integrarse a
              esta aplicación.
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              El usuario conoce que la aplicación estará disponible para acceder a los servicios por medio de dispositivos móviles.
              Para el uso de la aplicación deberá contar con un dispositivo móvil que sea compatible con el servicio. ExcelCredit S.A.
              no asegura que la aplicación vaya a ser compatible con su dispositivo móvil. La sociedad podrá realizar actualizaciones
              a la aplicación, lo que podrá requerir que el usuario modifique la versión de la aplicación que está utilizando en su
              dispositivo móvil para poder continuar usando el servicio. Dichas actualizaciones se regirán por los mismos términos y
              condiciones aquí establecidos.
            </ProspectingNumericListLine>
          </ProspectingNumericList>
          <ProspectingSubtitleParagraph>Licencia.</ProspectingSubtitleParagraph>
          <ProspectingParagraph>
            La aplicación, incluyendo todos sus contenidos, tales como texto, imágenes y la HTML, u otro código usado (“materiales”)
            son de propiedad de ExcelCredit S.A. o de sus proveedores o licenciantes y están protegidos por las leyes de Colombia.
            Excepto que se indique de otro modo en la presente, el usuario no podrá usar, descargar, subir, copiar, imprimir, exhibir,
            ejecutar, reproducir, publicar, modificar, borrar, agregar, licenciar, publicar en medios sociales, transmitir o distribuir
            ninguno de los materiales de la aplicación total o parcialmente, para ningún fin comercial o público sin permiso específico
            por escrito otorgado por la sociedad ExcelCredit S.A.
          </ProspectingParagraph>
          <ProspectingParagraph>
            ExcelCredit S.A. otorga al usuario una licencia no exclusiva, no transferible y revocable para utilizar una copia del código
            de la aplicación para una cuenta registrada en un dispositivo móvil perteneciente únicamente al usuario para su uso personal
            y que ha sido verificada previamente por la sociedad.
          </ProspectingParagraph>
          <ProspectingParagraph>
            Esta aplicación no puede ser copiada, reproducida, republicada, cargada, posteada, transmitida o distribuida de ninguna manera,
            exceptuando aquellas específicamente permisibles en estos términos. El usuario no podrá: (i) modificar, desarmar, descompilar o
            revertir la ingeniería de la aplicación; (ii) rentar, alquilar, prestar, revender, sub licenciar, distribuir o de otro modo transferir
            la aplicación a cualquier tercera parte o usar la aplicación para proporcionar tiempo compartido oservicios similares a terceros;
            (iii) hacer copias de la aplicación; (iv) quitar, sortear, deshabilitar, dañar o de otro modo interferir con las funciones de seguridad
            de la aplicación que restrinjan o prevengan el uso o la copia de cualquier contenido accesible a través de la aplicación, o
            funciones que refuercen las limitaciones al uso de la aplicación o (v) borrar el copyright y otros avisos de derechos propietarios
            sobre la aplicación. El usuario conoce que ExcelCredit S.A. podrá emitir regularmente versiones actualizadas de la aplicación
            y que puede actualizar automática o electrónicamente la versión de la aplicación que se está usando en el móvil.
          </ProspectingParagraph>
          <ProspectingSubtitleParagraph>Reglas y Límites para el Uso.</ProspectingSubtitleParagraph>
          <ProspectingSubtitleParagraph>Modificaciones a la Aplicación.</ProspectingSubtitleParagraph>
          <ProspectingParagraph>
            ExcelCredit S.A. se reserva el derecho por cualquier motivo, a su exclusiva discreción y sin notificarle al usuario,
            de terminar, cambiar, suspender o discontinuar cualquier aspecto de la Aplicación, incluyendo, pero sin limitarse a,
            información, datos, textos, música, sonido, fotografías, gráficos, video, mensajes o cualquier otro material (“contenido”)
            en sus funciones y/o horas de disponibilidad sin ninguna obligación hacia usted o cualquier tercera parte por hacerlo.
          </ProspectingParagraph>
          <ProspectingUnderlineParagraph>Usos específicos prohibidos</ProspectingUnderlineParagraph>
          <ProspectingParagraph>
            La Aplicación podrá ser usada únicamente con fines permitidos por ley, por personas autorizadas por ExcelCredit S.A.
            El usuario será responsable por sus comunicaciones, incluyendo la carga, transmisión y publicación de información, y
            de las consecuencias de estas en o a través de la Aplicación. ExcelCredit S.A. prohíbe cualquier uso de la Aplicación
            para cualquiera de las siguientes situaciones:
          </ProspectingParagraph>
          <ProspectingNumericList type="a">
            <ProspectingNumericListLine>Registrar información incompleta, falsa, inexacta, ilegal o que no le pertenezca;</ProspectingNumericListLine>
            <ProspectingNumericListLine>Hacerse pasar por otra persona;</ProspectingNumericListLine>
            <ProspectingNumericListLine>Transmitir o transferir (por cualquier medio) información o software derivado de la aplicación a cualquier tercero;</ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Tratar de interferir de algún modo con la seguridad de la Aplicación; o tratar de usar
              el servicio de esta para obtener acceso no autorizado a cualquier otro sistema de computadora, o tratar de publicar
              o transmitir información que tenga virus, bug o cualquier otro artículo perjudicial;
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Tratar de interferir de algún modo con la seguridad de la Aplicación; o tratar de usar
              el servicio de esta para obtener acceso no autorizado a cualquier otro sistema de computadora, o tratar de publicar o
              transmitir información que tenga virus, bug o cualquier otro artículo perjudicial;
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Violar alguno de los términos o condiciones o cualquier otro acuerdo que pueda tener con cualquier tercero (incluyendo
              sin limitaciones a cualquier empleador) con respecto a su uso, posesión, transmisión o almacenamiento de datos, o su retención
              de los datos de algún tercero sin su autorización.
            </ProspectingNumericListLine>
          </ProspectingNumericList>
          <ProspectingUnderlineParagraph>Reglas de seguridad</ProspectingUnderlineParagraph>
          <ProspectingParagraph>
            Las violaciones del sistema de seguridad de red pueden resultar en responsabilidad civil o penal. ExcelCredit S.A. investigará
            los hechos y puede involucrarse y cooperar con las autoridades que velan por el cumplimiento de la ley para procesar al usuario o los
            usuarios involucrados en tales violaciones. Está prohibida la violación o el intento de violación de la seguridad de la Aplicación,
            incluyendo, sin limitarse a, lo siguiente:
          </ProspectingParagraph>
          <ProspectingNumericList type="a">
            <ProspectingNumericListLine>
              Acceder a datos que no le corresponden como usuario o ingresar a un servidor o cuenta para las cuales
              no está autorizado;
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Intentar sondear, escanear o probar la vulnerabilidad de un sistema o red o violar la seguridad o medidas de autenticación
              sin la autorización correspondiente;
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              Intentar interferir con el servicio de cualquier usuario, anfitrión o red, incluyendo, sin limitación, a través de la presentación
              de un virus en la Aplicación, el sobre carga, la “inundación”, el “bombardeo de correos electrónicos” o el “crashing” o el envío de
              correos electrónicos no solicitados incluyendo promociones y/o publicidad de productos o servicios;
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              La ingeniería inversa, reconstrucción, copia, preparación de trabajos derivados o que de otro modo imiten a la Aplicación, o
            </ProspectingNumericListLine>
            <ProspectingNumericListLine>
              La falsificación de cualquier paquete TCP/OP o cualquier otra información de paquete en cualquier correo electrónico o publicación
              en grupos de noticias.
            </ProspectingNumericListLine>
          </ProspectingNumericList>
          <ProspectingSubtitleParagraph>Política de Privacidad.</ProspectingSubtitleParagraph>
          <ProspectingSubtitleParagraph>Información del Usuario.</ProspectingSubtitleParagraph>
          <ProspectingParagraph>
            Durante el uso de la Aplicación, la sociedad ExcelCredit S.A. le podrá solicitar que proporcione cierta información como usuario de
            la Aplicación. El uso de cualquier información suministrada por parte de ExcelCredit S.A. a través de la Aplicación estará regido por
            la política de privacidad disponible la aplicación y pagina Web www.excelcredirt.co, la cual el usuario deberá leer, conocer y entender
            su contenido.
          </ProspectingParagraph>
          <ProspectingSubtitleParagraph>Derechos Propietarios.</ProspectingSubtitleParagraph>
          <ProspectingParagraph>
            ExcelCredit S.A. es el propietario y/o autorizado de cualquier marca comercial, marca registrada y/o marca de servicio que aparece en
            la Aplicación y es el propietario del copyright o licenciante del contenido y/o la información en la Aplicación salvo que se indique de
            otro modo.
          </ProspectingParagraph>
          <ProspectingParagraph>
            Excepto que se indique de otro modo en el presente, el uso de la Aplicación no le otorga licencia de ningún contenido, funciones o materiales
            a los que el usuario puede acceder en la Aplicación y no puede modificar, rentar, alquilar, prestar, vender, distribuir o crear trabajaos
            derivados de tal contenido, funciones o materiales, total o parcialmente. Cualquier uso comercial de la Aplicación se encuentra terminantemente
            prohibido, excepto lo permitido en el presente documento o que de otro modo sea aprobado por ExcelCredit S.A. El usuario no podrá descargar
            o guardar copia alguna del contenido o de las pantallas para ningún propósito excepto lo especificado por ExcelCredit S.A. Si el usuario
            utiliza la Aplicación para fines diferentes a los estipulados en el presente documento, al hacerlo puede violar el copyright u otras leyes
            de Colombia, así como también leyes de otros países y podrá ser responsable por tal uso no autorizado. ExcelCredit S.A. no le otorga licencia
            u otra autorización a ningún usuario de las marcas comerciales, marcas registradas, marcas de servicio u otro material de copyright o cualquier
            otra propiedad intelectual contenida en la Aplicación. La información en la Aplicación incluyendo, pero, sin limitarse, todo el diseño, texto,
            gráficos, interfaces y selección y arreglos está protegida por la normatividad vigente y la ley de copyright.
          </ProspectingParagraph>
          <ProspectingParagraph>
            Los nombres de los productos, logos, diseños, títulos, palabras o frases se encuentran protegidas por ley, así como los nombres
            comerciales, las marcas de servicio o las marcas registradas de ExcelCredit S.A. Tales marcas registradas, marcas de servicio y nombres
            comerciales pueden estar registrados en Colombia.
          </ProspectingParagraph>
          <ProspectingParagraph>
            Los nombres de servicio y los logos de DigiCrédito y otros productos relacionados en la Aplicación son marcas comerciales de ExcelCredit
            S.A. Sin el permiso previo de ExcelCredit S.A., el usuario se compromete a no mostrar las marcas de ExcelCredit S.A. de ninguna forma.
          </ProspectingParagraph>
          <ProspectingSubtitleParagraph>Contáctese con <ProspectingSubtitleParagraphNormal>ExcelCredit S.A.</ProspectingSubtitleParagraphNormal></ProspectingSubtitleParagraph>
          <ProspectingParagraph>
            Para información adicional o inquietudes relacionadas con el presente términos y condiciones, podrá comunicarse a través del correo electrónico a <ProspectingParagraphLink>servicioalcliente@excelcredit.co</ProspectingParagraphLink>.
          </ProspectingParagraph>

        </TermsOfServiceContent>

        <TermsOfServiceAcceptArea>
          <TermsOfServiceCheckboxContent>
            <TermsOfServiceCheckbox onClick={() => setToggleCheckbox(!toggleCheckbox)} checked={toggleCheckbox} id="toggle-checkbox">
              <BsCheck color={toggleCheckbox ? colors.white : 'transparent'} id="check-icon" />
            </TermsOfServiceCheckbox>
            <TermsOfServiceCheckboxLabel>Confirmo que he leído y aceptado los términos</TermsOfServiceCheckboxLabel>
          </TermsOfServiceCheckboxContent>
        </TermsOfServiceAcceptArea>

        <TermsOfServiceButton onClick={() => acceptTermsOfServiceAction()} disabled={!enableButton} id="accept-terms">Siguiente </TermsOfServiceButton>

        <TermsOfServiceCopyright>
          <TermsOfServiceCopyrightImage src={copyrightImage} width={139} alt="Copyright Excel Credit" />
          <TermsOfServiceCopyrightTextLine>© ExcelCredit S.A. Todos los derechos reservados</TermsOfServiceCopyrightTextLine>
        </TermsOfServiceCopyright>
      </TermsOfServiceColumn>
    </TermsOfServiceContainer>
  )
}

export default TermsOfServicePage;
